import React from 'react';

import { CONTENT_PICKER } from '@lumapps/content-picker/keys';
import { mdiTextBoxOutline } from '@lumapps/lumx/icons';
import { NavigationItemType, NavigationMapItem, NavigationMapPageReferenceType } from '@lumapps/navigation/types';
import { GlobalPickerOption } from '@lumapps/pickers/components/GlobalPickerOption';
import { GLOBAL, useTranslate } from '@lumapps/translations';

import { NAVIGATION_ADMIN } from '../../keys';
import { NavigationItemWizardOptionProps } from '../../types';
import { generateNewNodeBase } from '../../utils';
import {
    PickerNavigationItemModal,
    PickerNavigationItemModalProps,
} from '../NavigationItemModal/PickerNavigationItemModal';

export interface ContentWizardOptionType extends NavigationItemWizardOptionProps {
    name?: string;
    description?: string;
    pageType?: NavigationMapPageReferenceType;
    pickerType?: PickerNavigationItemModalProps['pickerType'];
    id?: string;
    icon?: string;
}

export const ContentWizardOption: React.FC<ContentWizardOptionType> = ({
    fetchAtInstanceLevel,
    languages,
    defaultLanguage,
    setWasOptionSelected,
    onAdded,
    isOpen = false,
    scope,
    isDisabled,
    optionProps = {},
    navigationItemModalProps,
    name,
    description,
    icon = mdiTextBoxOutline,
    pageType = NavigationItemType.CONTENT,
    pickerType = NavigationItemType.CONTENT,
    id,
}) => {
    const { translateKey } = useTranslate();
    const [isModalOpen, setIsOpenModal] = React.useState<boolean>(isOpen);
    const ref = React.useRef(null);

    const onSectionSave = (navItem: NavigationMapItem) => {
        onAdded(navItem);
    };

    const pickerDefaultDescription = translateKey(
        fetchAtInstanceLevel ? CONTENT_PICKER.PICK_CONTENT_FROM_YOUR_SITE : NAVIGATION_ADMIN.PICK_CONTENT_DESCRIPTION,
    );

    return (
        <>
            <GlobalPickerOption
                icon={icon}
                name={name || translateKey(GLOBAL.CONTENTS)}
                description={description || pickerDefaultDescription}
                itemRef={ref}
                scope={scope}
                id={id || 'content'}
                isDisabled={isDisabled}
                onClick={() => {
                    setIsOpenModal(true);
                    setWasOptionSelected(true);
                }}
                {...optionProps}
            />
            {isModalOpen ? (
                <PickerNavigationItemModal
                    isOpen={isModalOpen}
                    languages={languages}
                    defaultLanguage={defaultLanguage}
                    onSave={onSectionSave}
                    buttonRef={ref}
                    scope={scope}
                    pickerType={pickerType}
                    navigationItem={generateNewNodeBase({
                        type: NavigationItemType.PAGE,
                        pageReference: {
                            type: pageType,
                        },
                    })}
                    onClose={() => {
                        setIsOpenModal(false);
                        setWasOptionSelected(false);
                    }}
                    navigationItemModalProps={navigationItemModalProps}
                />
            ) : null}
        </>
    );
};
